var $616e1217fe3c84b8$exports = {};
$616e1217fe3c84b8$exports = {
    "replaceMessage": `\u{41F}\u{443}\u{441}\u{43D}\u{435}\u{442}\u{435} \u{444}\u{430}\u{439}\u{43B} \u{437}\u{430} \u{437}\u{430}\u{43C}\u{44F}\u{43D}\u{430}`
};


export {$616e1217fe3c84b8$exports as default};
//# sourceMappingURL=bg-BG.mjs.map
